import { render, staticRenderFns } from "./ClinicNurseDashboardFooter.vue?vue&type=template&id=97a52d2e&"
import script from "./ClinicNurseDashboardFooter.vue?vue&type=script&lang=js&"
export * from "./ClinicNurseDashboardFooter.vue?vue&type=script&lang=js&"
import style0 from "./ClinicNurseDashboardFooter.vue?vue&type=style&index=0&id=97a52d2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports